(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('activarControlHorarioController', activarControlHorarioController);


    activarControlHorarioController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'common', 'userService'
    ];


    function activarControlHorarioController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, common, userService ) {

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.goToSubscription = goToSubscription; 
        (function () {
            
        })();

        function goToSubscription() {
            $state.go('flota.suscripciones.general');
        }

    }
})();
